import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate, Link } from 'react-router';
import { useAuth } from '@/hooks/use-auth';

export function MagicLinkVerifyPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { verifyMagicLink } = useAuth();
  const [error, setError] = useState('');
  const [verifying, setVerifying] = useState(true);

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      setError('No token provided');
      setVerifying(false);
      return;
    }

    verifyMagicLink(token)
      .then(() => {
        // Redirect through `/` so HomeRedirect can pick the first nav item
        // this user actually has access to (vs. blindly /dashboard).
        navigate('/', { replace: true });
      })
      .catch((err) => {
        setError(err.message || 'Verification failed');
        setVerifying(false);
      });
  }, [searchParams, verifyMagicLink, navigate]);

  if (verifying) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background">
        <div className="text-center space-y-4">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto" />
          <p className="text-sm text-muted-foreground">Verifying your sign-in link...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-4">
      <div className="w-full max-w-sm space-y-6 text-center">
        <h1 className="text-2xl font-bold font-heading text-destructive">Verification Failed</h1>
        <p className="text-sm text-muted-foreground">{error}</p>
        <Link to="/auth/login" className="inline-block text-sm text-primary hover:underline">
          Back to sign in
        </Link>
      </div>
    </div>
  );
}
